import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { ToastService, useDataTable, useDataTableBasic } from '@iamsoftware/react-hooks';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { TabView, TabPanel } from 'primereact/tabview';
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { AgreementService } from '../../../service/AgreementService';
import { DocumentSignService } from '../../../service/DocumentSignService';
import { Oauth2GoogleService } from '../../hop-dong/mau-hop-dong/Oauth2GoogleService';
import { GoogleService } from '../GoogleService';
import { UploadExcel } from '../UploadExcel';
import { AgreementConfigService } from '../../../service/AgreementConfigService';
import { CommonService } from '../../../service/CommonService';

export const TaiLieuKy: React.FC = () => {
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [headerResult, setHeaderResult] = useState<any>(null);
    const [agreementParties, setAgreementParties] = useState<any[]>([]);
    const [displaySignerDialog, setDisplaySignerDialog] = useState<any>(null);
    const [isSigning, setIsSigning] = useState(false);
    const [cancelDialog, setCancelDialog] = useState<any>(null);
    const [cancelReason, setCancelReason] = useState<string>('');
    const [showFileViewer, setShowFileViewer] = useState(false);
    const [viewerUrl, setViewerUrl] = useState<string | null>(null);
    const [viewerFileName, setViewerFileName] = useState<string>('');
    const [displayEmailDialog, setDisplayEmailDialog] = useState<any>(null);
    const [emailParties, setEmailParties] = useState<any[]>([]);
    const [sendingEmail, setSendingEmail] = useState(false);
    const [displayUploadExcel, setDisplayUploadExcel] = useState(false);
    const [displayFileDialog, setDisplayFileDialog] = useState<any>(null);
    const [fileDialogMainFiles, setFileDialogMainFiles] = useState<any[]>([]);
    const [fileDialogAttachmentFiles, setFileDialogAttachmentFiles] = useState<any[]>([]);
    const [fileDialogActiveTabIndex, setFileDialogActiveTabIndex] = useState(0);
    const [fileDialogViewingAttachmentIndex, setFileDialogViewingAttachmentIndex] = useState<number | null>(null);
    const fileDialogOpenedFileIdsRef = useRef<Set<string>>(new Set());
    const [fileDialogMainFileReady, setFileDialogMainFileReady] = useState<{ [key: string]: boolean }>({});
    const [fileDialogAttachmentFileReady, setFileDialogAttachmentFileReady] = useState<{ [key: string]: boolean }>({});
    const fileDialogMainFileBlobUrlsRef = useRef<{ [key: string]: string }>({});
    const fileDialogAttachmentFileBlobUrlsRef = useRef<{ [key: string]: string }>({});
    const [fileDialogMainFileBlobUrls, setFileDialogMainFileBlobUrls] = useState<{ [key: string]: string }>({});
    const [fileDialogAttachmentFileBlobUrls, setFileDialogAttachmentFileBlobUrls] = useState<{ [key: string]: string }>({});
    const [displayUploadAttachmentDialog, setDisplayUploadAttachmentDialog] = useState<any>(null);
    const [uploadingAttachment, setUploadingAttachment] = useState(false);
    const fileUploadAttachmentRef = useRef<FileUpload>(null);
    const [uploadDialogDocumentTypeItems, setUploadDialogDocumentTypeItems] = useState<any[]>([]);
    const [uploadDialogDocumentTypeItemMeta, setUploadDialogDocumentTypeItemMeta] = useState<Record<string, { formType?: string | null; receivedDate?: Date | null }>>({});
    const [uploadDialogDocumentTypeItemsLoading, setUploadDialogDocumentTypeItemsLoading] = useState<boolean>(false);
    const [uploadDialogFileTypes, setUploadDialogFileTypes] = useState<any[]>([]);
    const [uploadDialogAttachedFiles, setUploadDialogAttachedFiles] = useState<any[]>([]);
    const [uploadDialogAgreementType, setUploadDialogAgreementType] = useState<string | null>(null);
    const [showUploadDialogFileViewer, setShowUploadDialogFileViewer] = useState<boolean>(false);
    const [uploadDialogViewerUrl, setUploadDialogViewerUrl] = useState<string | null>(null);
    const [uploadDialogSelectedFile, setUploadDialogSelectedFile] = useState<any>(null);

    useEffect(() => {
        setHeaderResult(
            <div className="flex align-items-center justify-content-between ">
                <span>Quản lý tài liệu</span>
            </div>
        );
    }, []);
    const [statuses, setStatuses] = useState<any[]>([]);
    const handleSign = (item: any) => {
        if (!item?.agreementId) return;
        AgreementService.unsignedParties(item.agreementId).then(res => {
            const parties = (res?.agreementParties || []).map((p: any) => ({
                ...p,
                checked: p.checked === 'Y',
                dataKey: `${p.roleTypeId}-${p.partyId}`
            }));
            setAgreementParties(parties);
            setDisplaySignerDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
        });
    };

    const handleCancel = (item: any) => {
        if (!item?.agreementId) return;
        setCancelDialog(item);
        setCancelReason('');
    };

    const handleConvertToDraft = (item: any) => {
        if (!item?.agreementId) return;
        AgreementService.convertToDraft(item.agreementId).then(res => {
            if (res && res.success === 'Y') {
                ToastService.success('Đã chuyển tài liệu về nháp');
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể chuyển tài liệu về nháp');
            }
        }).catch(() => ToastService.error('Có lỗi khi chuyển tài liệu về nháp'));
    };

    // Handlers for Draft tab
    const handleView = (rowData: any) => {
        navigate(`/quan-ly-tai-lieu/tai-lieu/${rowData.agreementId}?mode=view`);
    };

    const handleEdit = (rowData: any) => {
        navigate(`/quan-ly-tai-lieu/tai-lieu/${rowData.agreementId}`);
    };

    const handleSignFromDraft = (rowData: any) => {
        try {
            AgreementService.signAgreement(rowData.agreementId).then(res => {
                if (res && res.success === 'Y') {
                    try {
                        if (typeof window !== 'undefined' && window.localStorage) {
                            window.localStorage.setItem('econtract.taiLieuKy.activeTab', '1');
                        }
                    } catch (err) {
                    }
                    setActiveTabIndex(1);
                    reloadLazyData();
                } else {
                    ToastService.error(res?.error || 'Không thể ký hợp đồng');
                }
            });
        } catch (e) {
            ToastService.error('Có lỗi khi ký hợp đồng');
        }
    };

    const handleDelete = async (rowData: any) => {
        try {
            const res = await AgreementService.moveToTrash(rowData.agreementId);
            if (res && res.success === 'Y') {
                ToastService.success('Đã chuyển vào thùng rác');
                setActiveTabIndex(4);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '4');
                    }
                } catch (err) { }
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể chuyển vào thùng rác');
            }
        } catch (e) {
            ToastService.error('Có lỗi khi chuyển vào thùng rác');
        }
    };

    // Handler for Trash tab
    const handleRestore = async (rowData: any) => {
        try {
            const id = rowData.agreementId;
            const res = await AgreementService.restoreAgreement(id);
            if (res && res.success === 'Y') {
                ToastService.success('Đã khôi phục tài liệu');
                setActiveTabIndex(0);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '0');
                    }
                } catch (err) { }
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể khôi phục tài liệu');
            }
        } catch (e) {
            ToastService.error('Có lỗi khi khôi phục tài liệu');
        }
    };

    const handleSendEmail = (item: any) => {
        if (!item?.agreementId) return;
        AgreementService.unsignedParties(item.agreementId).then(res => {
            const parties = (res?.agreementParties || []).map((p: any) => ({
                ...p,
                checked: false,
                dataKey: `${p.roleTypeId}-${p.partyId}`
            }));
            setEmailParties(parties);
            setDisplayEmailDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
        }).catch(() => {
            ToastService.error('Không thể tải danh sách đối tượng');
        });
    };

    const confirmCancel = () => {
        if (!cancelDialog?.agreementId) return;
        const reason = cancelReason.trim();
        if (!reason) {
            ToastService.error('Vui lòng nhập lý do hủy');
            return;
        }
        const agreementId = cancelDialog.agreementId;
        setCancelDialog(null);
        setCancelReason('');
        AgreementService.cancelAgreement(agreementId, { cancelReason: reason }).then(res => {
            if (!res.errors) {
                ToastService.success('Đã hủy tài liệu');
                setActiveTabIndex(3);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '3');
                    }
                } catch (err) { }
                reloadLazyData();
            } else {
                ToastService.error(res?.errors || 'Không thể hủy tài liệu');
            }
        }).catch(() => ToastService.error('Có lỗi khi hủy tài liệu'));
    };

    const { render: renderSignerTable } = useDataTableBasic({
        tableHeader: 'Đối tượng',
        dataKey: 'dataKey',
        indexColumnWidth: 45,
        columns: [
            {
                field: 'checked', header: 'Chọn', width: 120,
                dataType: 'editor', editorConfig: {
                    onEditorChange(rowData: any, column: any, newValue: any) {
                        setAgreementParties(prev => prev.map(it => it.dataKey === rowData.dataKey ? { ...it, checked: newValue } : { ...it, checked: false }));
                    },
                    field: { type: 'Checkbox' }
                }, className: 'text-center'
            },
            { field: 'partyName', header: 'Tên đối tượng', minWidth: 150 },
            { field: 'roleType', header: 'Vai trò', minWidth: 75 },
            { field: 'emailAddress', header: 'Email', minWidth: 100 },
            { field: 'contactNumber', header: 'SĐT', minWidth: 90 },
            { header: 'MST/CCCD/CMND', minWidth: 120, dataType: 'custom', customCell(row: any) { return row.taxCode || row.identityCard || ''; } }
        ],
        items: agreementParties
    });

    const { render: renderEmailTable } = useDataTableBasic({
        tableHeader: 'Đối tượng',
        dataKey: 'dataKey',
        indexColumnWidth: 45,
        columns: [
            {
                field: 'checked', header: 'Chọn', width: 120,
                dataType: 'editor', editorConfig: {
                    onEditorChange(rowData: any, column: any, newValue: any) {
                        setEmailParties(prev => prev.map(it => it.dataKey === rowData.dataKey ? { ...it, checked: newValue } : it));
                    },
                    field: { type: 'Checkbox' }
                }, className: 'text-center'
            },
            { field: 'partyName', header: 'Tên đối tượng', minWidth: 150 },
            { field: 'roleType', header: 'Vai trò', minWidth: 75 },
            { field: 'emailAddress', header: 'Email', minWidth: 100 },
            { field: 'contactNumber', header: 'SĐT', minWidth: 90 },
            { header: 'MST/CCCD/CMND', minWidth: 120, dataType: 'custom', customCell(row: any) { return row.taxCode || row.identityCard || ''; } }
        ],
        items: emailParties
    });

    const submitSignSelected = async () => {
        const selected = agreementParties.find(p => p.checked === true);
        if (!selected) { ToastService.error('Chưa chọn đối tượng ký.'); return; }
        if (isSigning) return;
        setIsSigning(true);
        try {
            const row = selected;
            const signResult = await DocumentSignService.sign({
                agreementId: row.agreementId,
                partyId: row.partyId,
                roleTypeId: row.roleTypeId
            });

            if (signResult?.success && signResult?.data?.signedFilesBase64?.length > 0) {
                const signedPdfBase64 = signResult.data.signedFilesBase64[0];
                await AgreementService.pushSignedData({
                    signedBy: row.roleTypeId === 'SellerSignedExec' ? 'SELLER' : 'BUYER',
                    base64FileData: signedPdfBase64,
                    agreementId: row.agreementId,
                    partyId: row.partyId,
                    roleTypeId: row.roleTypeId,
                    referenceNumber: null,
                    signingSecretCode: ''
                });
                ToastService.success('Ký số thành công!');
            } else {
                try { await AgreementService.updateSigningError({ agreementId: row.agreementId, partyId: row.partyId, roleTypeId: row.roleTypeId, referenceNumber: null, signingSecretCode: '' }); } catch { }
            }
            setDisplaySignerDialog(null);
            reloadLazyData();
        } catch (e) {
            ToastService.error('Có lỗi khi ký/lưu file từ server.');
        } finally {
            setIsSigning(false);
        }
    };

    const submitEmailSelected = async () => {
        const selected = emailParties.filter(p => p.checked === true);
        if (selected.length === 0) {
            ToastService.error('Chưa chọn đối tượng để gửi email.');
            return;
        }
        if (!displayEmailDialog?.agreementId) return;
        if (sendingEmail) return;

        setSendingEmail(true);
        try {
            const agreementPartiesData = selected.map(p => ({
                partyId: p.partyId,
                roleTypeId: p.roleTypeId,
                toAddresses: p.emailAddress || ''
            }));

            await AgreementService.sentEmailNotifyBuyer(displayEmailDialog.agreementId, {
                agreementParties: agreementPartiesData,
                subject: `Thông báo hợp đồng cần ký - ${displayEmailDialog.agreementName || ''}`
            });

            ToastService.success('Gửi email thành công!');
            setDisplayEmailDialog(null);
            setEmailParties([]);
            reloadLazyData();
        } catch (error: any) {
            const errorMsg = error?.response?.data?.errors || error?.message || 'Có lỗi khi gửi email';
            ToastService.error(errorMsg);
        } finally {
            setSendingEmail(false);
        }
    };

    const openPdfInNewTab = async (agreementId?: string, fileId?: string, fileName?: string) => {
        if (!fileId) {
            ToastService.error('Không tìm thấy file để xem');
            return;
        }
        try {
            await AgreementService.openContent(agreementId, fileId);
            const blob = await Oauth2GoogleService.getPdf(fileId);
            const url = URL.createObjectURL(blob);

            if (viewerUrl && viewerUrl.startsWith('blob:')) {
                URL.revokeObjectURL(viewerUrl);
            }

            setViewerUrl(url);
            if (fileName) {
                setViewerFileName(fileName);
            } else {
                setViewerFileName('');
            }
            setShowFileViewer(true);
            await AgreementService.closeContent(agreementId, fileId);
        } catch (error) {
            ToastService.error('Không thể tải file PDF');
        }
    };

    const downloadFile = async (fileId?: string, fileName?: string) => {
        if (!fileId) {
            ToastService.error('Không tìm thấy file để tải');
            return;
        }
        try {
            const blob = await Oauth2GoogleService.getPdf(fileId);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'document.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            ToastService.success('Đã tải file thành công');
        } catch (error) {
            ToastService.error('Không thể tải file');
        }
    };

    const closeFileViewer = () => {
        if (viewerUrl && viewerUrl.startsWith('blob:')) {
            URL.revokeObjectURL(viewerUrl);
        }
        setViewerUrl(null);
        setViewerFileName('');
        setShowFileViewer(false);
    };

    const handleShowFiles = async (item: any) => {
        if (!item?.agreementId) return;
        try {
            const data = await AgreementService.getAgreementFiles(item.agreementId);
            setFileDialogMainFiles(data?.mainFiles || []);
            setFileDialogAttachmentFiles(data?.attachmentFiles || []);
            setFileDialogMainFileReady({});
            setFileDialogAttachmentFileReady({});
            setFileDialogMainFileBlobUrls({});
            setFileDialogAttachmentFileBlobUrls({});
            fileDialogMainFileBlobUrlsRef.current = {};
            fileDialogAttachmentFileBlobUrlsRef.current = {};
            setFileDialogViewingAttachmentIndex(null);
            setFileDialogActiveTabIndex(0);
            setDisplayFileDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
        } catch (error) {
            ToastService.error('Không thể tải danh sách file');
        }
    };

    const resolveConfigItemSeq = (item: any, fallbackIndex?: number): number | null => {
        if (!item) return fallbackIndex !== undefined ? fallbackIndex + 1 : null;
        const seq =
            item.sequenceNum ??
            item.configSequenceNum ??
            item.agreementItemSeq ??
            item.agreementConfigureItemSeq ??
            item.id ??
            item.value ??
            (fallbackIndex !== undefined ? fallbackIndex + 1 : null);
        const parsed = Number(seq);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const getFileTypeName = (item: any): string => {
        if (!item) return 'Không có mô tả';
        const fileTypeId = item.fileTypeEnumId || item.fileTypeId;
        if (!fileTypeId || uploadDialogFileTypes.length === 0) return item.description || 'Không có mô tả';
        const fileType = uploadDialogFileTypes.find((ft: any) => ft.enumId === fileTypeId || ft.enumCode === fileTypeId);
        return fileType?.description || item.description || 'Không có mô tả';
    };

    const normalizeFormTypeValue = (input?: string | null) => {
        if (!input) return null;
        const str = String(input);
        const formTypeOptions = uploadDialogFileTypes.length > 0
            ? uploadDialogFileTypes.map((ft: any) => ({
                label: String(ft.description || ft.enumName || ft.enumId || ''),
                value: String(ft.enumId || ft.value || ft.enumCode || ''),
                enumCode: ft.enumCode ? String(ft.enumCode) : String(ft.enumId || '')
            }))
            : [
                { label: 'Bản mềm', value: 'DIGITAL_COPY', enumCode: 'DIGITAL' },
                { label: 'Bản cứng', value: 'HARD_COPY', enumCode: 'HARD' }
            ];
        const option = formTypeOptions.find((opt: any) => opt.value === str || opt.enumCode === str);
        if (option) return option.value;
        if (str === 'SOFT') return 'DIGITAL_COPY';
        if (str === 'HARD') return 'HARD_COPY';
        return str;
    };

    const getFileExtension = (filename?: string): string => {
        if (!filename || typeof filename !== 'string') return '';
        return filename.split('.').pop()?.toLowerCase() || '';
    };

    const uploadDialogFormTypeOptions = useMemo(() => {
        if (uploadDialogFileTypes.length > 0) {
            return uploadDialogFileTypes.map((ft: any) => ({
                label: String(ft.description || ft.enumName || ft.enumId || ''),
                value: String(ft.enumId || ft.value || ft.enumCode || ''),
                enumCode: ft.enumCode ? String(ft.enumCode) : String(ft.enumId || '')
            }));
        }
        return [
            { label: 'Bản mềm', value: 'DIGITAL_COPY', enumCode: 'DIGITAL' },
            { label: 'Bản cứng', value: 'HARD_COPY', enumCode: 'HARD' }
        ];
    }, [uploadDialogFileTypes]);

    const [activeTabIndex, setActiveTabIndex] = useState(0);

    useEffect(() => {
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                const savedIndex = window.localStorage.getItem('econtract.taiLieuKy.activeTab');
                if (savedIndex !== null) {
                    const parsed = parseInt(savedIndex, 10);
                    if (!Number.isNaN(parsed)) {
                        setActiveTabIndex(parsed);
                    }
                }
            }
        } catch (e) {
        }
    }, []);

    const handleTabChange = (e: { index: number }) => {
        const newIndex = e.index;
        setActiveTabIndex(newIndex);
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('econtract.taiLieuKy.activeTab', String(newIndex));
            }
        } catch (err) {
        }
    };

    const columns: any[] = [
        {
            field: 'agreementName', header: 'Tên tài liệu', width: 100, matchMode: 'contains', dataType: 'custom' as const, customCell(row: any) {
                return <span className="underline text-primary" onClick={() => navigate(`/quan-ly-tai-lieu/tai-lieu/${row.agreementId}?mode=view`)} title="Xem chi tiết">{row.agreementName}</span>
            }
        },
        { field: 'agreementNo', header: 'Mã tài liệu', width: 140, matchMode: 'contains' },
        { field: 'agreementTypeName', header: 'Loại tài liệu', width: 160, matchMode: 'contains' },
        {
            field: 'statusDescription', header: 'Trạng thái', width: 200, dataType: 'custom' as const, customCell(row: any) {
                const map: any = {
                    'AGT_SIGNING_PROCESS': { severity: 'warning', label: 'Đang xử lý ' },
                    'AGT_SIGNING': { severity: 'warning', label: 'Đang ký' },
                    'AGT_SIGN_COMPLETED': { severity: 'success', label: 'Hoàn thành' },
                    'AGT_CANCELLED': { severity: 'danger', label: 'Đã hủy' }
                };
                const s = map[row.statusId] || { severity: 'secondary', label: row.statusDescription || 'N/A' };
                const isUrgent = row.isUrgent === 'Y';
                const isImportant = row.isImportant === 'Y';
                return (
                    <div className="flex align-items-center gap-2 flex-wrap">
                        <Tag value={s.label} severity={s.severity as any} />
                        {isUrgent && (
                            <span className="flex align-items-center gap-1 text-orange-500 text-sm" title="Tài liệu cần xử lý gấp">
                                <i className="pi pi-bolt"></i>
                                <span>Khẩn cấp</span>
                            </span>
                        )}
                        {isImportant && (
                            <span className="flex align-items-center gap-1 text-indigo-500 text-sm" title="Tài liệu quan trọng">
                                <i className="pi pi-bookmark"></i>
                                <span>Quan trọng</span>
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            field: 'mainContent', header: 'File ký', width: 220, dataType: 'custom' as const, customCell(row: any) {
                if (!row.mainContent) return <span className="text-gray-500">Chưa có file</span>;
                return (
                    <div className="flex align-items-center gap-2">
                        <i className={`pi ${row.mainContent.contentType === 'application/pdf' ? 'pi-file-pdf' : 'pi-file-word'} text-xl`}></i>
                        <div>
                            <div className="font-medium">{row.mainContent.fileName}</div>
                            <small className="text-gray-500">{row.mainContent.contentType?.split('/')?.[1]?.toUpperCase()}</small>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'contentCount',
            header: 'Số file',
            width: 110,
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                const count = rowData.contentCount || 0;
                return (
                    <Tag
                        value={`${count} file`}
                        severity="info"
                        style={{ cursor: count > 0 ? 'pointer' : 'default' }}
                        onClick={() => count > 0 && handleShowFiles(rowData)}
                        title={count > 0 ? 'Click để xem danh sách file' : ''}
                    />
                );
            }
        },
        {
            field: 'expiryDate',
            header: 'Thời gian',
            width: 180,
            dataType: 'custom',
            customCell(rowData: any): any {
                const formatLocal = (value?: any) => {
                    if (!value) return null;
                    const d = new Date(value);
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    const HH = String(d.getHours()).padStart(2, '0');
                    const MM = String(d.getMinutes()).padStart(2, '0');
                    const SS = String(d.getSeconds()).padStart(2, '0');
                    return `${dd}/${mm}/${yyyy} ${HH}:${MM}:${SS}`;
                };

                const expiryText = rowData.expiryDate ? formatLocal(rowData.expiryDate) : 'Không có thời hạn ký';
                const updatedText = rowData.lastUpdatedStamp ? formatLocal(rowData.lastUpdatedStamp) : null;

                return (
                    <div className="text-sm">
                        <div className="flex align-items-center gap-2 mb-1">
                            <i className="pi pi-hourglass" />
                            <span>{expiryText}</span>
                        </div>
                        {updatedText && (
                            <div className="flex align-items-center gap-2">
                                <i className="pi pi-clock" />
                                <span>{updatedText}</span>
                            </div>
                        )}
                    </div>
                );
            }
        }
    ];

    const mapListResult = (result: any) => {
        if (result.listData && Array.isArray(result.listData)) {
            result.listData = result.listData.map((item: any) => ({
                ...item,
                mainContent: item.mainFileName || item.mainContentType ? {
                    fileName: item.mainFileName,
                    contentType: item.mainContentType,
                    contentLocation: item.mainContentLocation,
                    fileId: item.fileId || item.mainFileId || item.mainContentId
                } : null
            }));
        }
        const total = result.totalRecords ?? (result.listData || []).length;
        return {
            listData: result.listData || [],
            totalRecords: total,
            totalCount: total
        };
    };

    const getInProgressList = (lazyLoadEvent: any) => {
        const statuses = JSON.stringify(['AGT_SIGNING_PROCESS', 'AGT_CREATED', 'AGT_SIGNING']);
        return AgreementService.getAgreementList(lazyLoadEvent, statuses as any).then(mapListResult);
    };

    const getCompletedList = (lazyLoadEvent: any) => {
        return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_SIGN_COMPLETED').then(mapListResult);
    };

    const getCancelledList = (lazyLoadEvent: any) => {
        return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_CANCELLED').then(mapListResult);
    };

    const getTrashList = (lazyLoadEvent: any) => {
        return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_DELETED').then(mapListResult);
    };

    const initActionsFactory = () => {
        return (items: Array<any>) => {
            items?.forEach(item => {
                const isCompleted = item.statusId === 'AGT_SIGN_COMPLETED';
                const isCancelled = item.statusId === 'AGT_CANCELLED';
                const mainFileId = item?.mainContent?.fileId || item?.fileId;
                const hasMainFileUrl = item?.mainContent?.contentLocation;
                const mainFileName = item?.mainContent?.fileName || '';
                const actions: any[] = [];

                if (isCompleted) {
                    if (mainFileId || hasMainFileUrl) {
                        actions.push({
                            icon: 'pi pi-external-link',
                            title: 'Xem file',
                            className: 'p-button-help',
                            command: async () => {
                                if (mainFileId) {
                                    openPdfInNewTab(item.agreementId, mainFileId, mainFileName);
                                } else if (hasMainFileUrl) {
                                    // Extract fileId from Google Drive URL if possible
                                    const googleDriveMatch = hasMainFileUrl.match(/\/file\/d\/([a-zA-Z0-9_-]+)/) || hasMainFileUrl.match(/[?&]id=([a-zA-Z0-9_-]+)/);
                                    const extractedFileId = googleDriveMatch ? googleDriveMatch[1] : null;

                                    if (extractedFileId) {
                                        // Use openPdfInNewTab to ensure openContent/closeContent is called
                                        openPdfInNewTab(item.agreementId, extractedFileId, mainFileName);
                                    } else {
                                        // Fallback to direct URL if not Google Drive
                                        setViewerUrl(hasMainFileUrl);
                                        setViewerFileName(mainFileName || '');
                                        setShowFileViewer(true);
                                    }
                                } else {
                                    ToastService.error('Không tìm thấy file để xem');
                                }
                            }
                        });
                    }
                    actions.push({
                        icon: 'pi pi-upload',
                        title: 'Cập nhật file đính kèm',
                        className: 'p-button-info',
                        command: () => {
                            setDisplayUploadAttachmentDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
                        }
                    });
                    actions.push({
                        icon: 'pi pi-times',
                        title: 'Hủy',
                        className: 'p-button-danger',
                        command: () => { if (!isSigning) handleCancel(item); }
                    });
                } else {
                    actions.push(
                        (mainFileId || hasMainFileUrl)
                            ? {
                                icon: 'pi pi-external-link',
                                title: 'Xem file',
                                className: 'p-button-help',
                                command: async () => {
                                    if (mainFileId) {
                                        openPdfInNewTab(item.agreementId, mainFileId, mainFileName);
                                    } else if (hasMainFileUrl) {
                                        // Extract fileId from Google Drive URL if possible
                                        const googleDriveMatch = hasMainFileUrl.match(/\/file\/d\/([a-zA-Z0-9_-]+)/) || hasMainFileUrl.match(/[?&]id=([a-zA-Z0-9_-]+)/);
                                        const extractedFileId = googleDriveMatch ? googleDriveMatch[1] : null;

                                        if (extractedFileId) {
                                            // Use openPdfInNewTab to ensure openContent/closeContent is called
                                            openPdfInNewTab(item.agreementId, extractedFileId, mainFileName);
                                        } else {
                                            // Fallback to direct URL if not Google Drive
                                            setViewerUrl(hasMainFileUrl);
                                            setViewerFileName(mainFileName || '');
                                            setShowFileViewer(true);
                                        }
                                    } else {
                                        ToastService.error('Không tìm thấy file để xem');
                                    }
                                }
                            }
                            : {
                                icon: 'pi pi-eye',
                                title: 'Xem chi tiết',
                                className: 'p-button-info',
                                command: () => navigate(`/quan-ly-tai-lieu/tai-lieu/${item.agreementId}?mode=view`)
                            }
                    );

                    if (!isCancelled) {
                        actions.push(
                            { icon: 'pi pi-user-edit', title: 'Ký', className: 'p-button-success', command: () => { if (!isSigning) handleSign(item); } }
                        );
                        actions.push(
                            { icon: 'pi pi-send', title: 'Gửi email', className: 'p-button-help', command: () => { if (!sendingEmail) handleSendEmail(item); } }
                        );
                        actions.push({
                            icon: 'pi pi-upload',
                            title: 'Cập nhật file đính kèm',
                            className: 'p-button-info',
                            command: () => {
                                setDisplayUploadAttachmentDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
                            }
                        });

                        if (item.partyCount > 0) {
                            actions.push(
                                { icon: 'pi pi-times', title: 'Hủy', className: 'p-button-danger', command: () => { if (!isSigning) handleCancel(item); } }
                            );
                        } else {
                            actions.push(
                                { icon: 'pi pi-undo', title: 'Chuyển về nháp', className: 'p-button-warning', command: () => { if (!isSigning) handleConvertToDraft(item); } }
                            );
                        }
                    }
                }
                item.actions = actions;
            });
        };
    };

    const { render: renderInProgress, reloadLazyData: reloadInProgress } = useDataTable({
        tableHeader: headerResult,
        dataKey: 'agreementId',
        indexColumnWidth: 45,
        actionColumnWidth: 170,
        columns: columns,
        getList: getInProgressList,
        initActions: initActionsFactory(),
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    const { render: renderCompleted, reloadLazyData: reloadCompleted } = useDataTable({
        tableHeader: headerResult,
        dataKey: 'agreementId',
        indexColumnWidth: 45,
        actionColumnWidth: 170,
        columns: columns,
        getList: getCompletedList,
        initActions: initActionsFactory(),
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    const { render: renderCancelled, reloadLazyData: reloadCancelled } = useDataTable({
        tableHeader: headerResult,
        dataKey: 'agreementId',
        indexColumnWidth: 45,
        actionColumnWidth: 170,
        columns: columns,
        getList: getCancelledList,
        initActions: initActionsFactory(),
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    const draftColumns: any[] = [
        {
            field: 'agreementName',
            header: 'Tên tài liệu',
            width: 100,
            matchMode: 'contains',
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                return <span className="underline text-primary" onClick={() => handleView(rowData)} title="Click để xem chi tiết">{rowData.agreementName}</span>
            }
        },
        { field: 'agreementNo', header: 'Mã tài liệu', width: 120, matchMode: 'contains' },
        { field: 'agreementTypeName', header: 'Loại tài liệu', width: 150, matchMode: 'contains' },
        {
            field: 'statusDescription',
            header: 'Trạng thái',
            width: 120,
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                const isUrgent = rowData.isUrgent === 'Y';
                const isImportant = rowData.isImportant === 'Y';
                return (
                    <div className="flex align-items-center gap-2 flex-wrap">
                        <Tag value="Nháp" severity="secondary" />
                        {isUrgent && (
                            <span className="flex align-items-center gap-1 text-orange-500 text-sm" title="Tài liệu cần xử lý gấp">
                                <i className="pi pi-bolt"></i>
                                <span>Khẩn cấp</span>
                            </span>
                        )}
                        {isImportant && (
                            <span className="flex align-items-center gap-1 text-indigo-500 text-sm" title="Tài liệu quan trọng">
                                <i className="pi pi-bookmark"></i>
                                <span>Quan trọng</span>
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            field: 'mainContent',
            header: 'File ký',
            width: 200,
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                if (!rowData.mainFileName && !rowData.mainContentLocation) return <span className="text-gray-500">Chưa có file</span>;
                const isPdf = rowData.mainContentType === 'application/pdf';
                const isWord = rowData.mainContentType?.includes('word') || rowData.mainContentType?.includes('document');
                const iconClass = isPdf ? 'pi-file-pdf' : (isWord ? 'pi-file-word' : 'pi-file');
                return (
                    <div className="flex align-items-center gap-2">
                        <i className={`pi ${iconClass} text-xl`}></i>
                        <div>
                            <div className="font-medium">{rowData.mainFileName}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'contentCount',
            header: 'Số file',
            width: 100,
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                const count = rowData.contentCount || 0;
                return (
                    <Tag
                        value={`${count} file`}
                        severity="info"
                        style={{ cursor: count > 0 ? 'pointer' : 'default' }}
                        onClick={() => count > 0 && handleShowFiles(rowData)}
                        title={count > 0 ? 'Click để xem danh sách file' : ''}
                    />
                );
            }
        },
        {
            field: 'expiryDate',
            header: 'Thời gian',
            width: 180,
            dataType: 'custom',
            customCell(rowData: any): any {
                const formatLocal = (value?: any) => {
                    if (!value) return null;
                    const d = new Date(value);
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    const HH = String(d.getHours()).padStart(2, '0');
                    const MM = String(d.getMinutes()).padStart(2, '0');
                    const SS = String(d.getSeconds()).padStart(2, '0');
                    return `${dd}/${mm}/${yyyy} ${HH}:${MM}:${SS}`;
                };

                const expiryText = rowData.expiryDate ? formatLocal(rowData.expiryDate) : 'Không có thời hạn ký';
                const updatedText = rowData.lastUpdatedStamp ? formatLocal(rowData.lastUpdatedStamp) : null;

                return (
                    <div className="text-sm">
                        <div className="flex align-items-center gap-2 mb-1">
                            <i className="pi pi-hourglass" />
                            <span>{expiryText}</span>
                        </div>
                        {updatedText && (
                            <div className="flex align-items-center gap-2">
                                <i className="pi pi-clock" />
                                <span>{updatedText}</span>
                            </div>
                        )}
                    </div>
                );
            }
        },
    ];

    const trashColumns: any[] = [
        {
            field: 'agreementName',
            header: 'Tên tài liệu',
            width: 220,
            matchMode: 'contains',
            dataType: 'custom' as const,
            customCell(rowData: any): any {
                return <span className="underline text-primary" onClick={() => handleView(rowData)} title="Click để xem chi tiết">{rowData.agreementName}</span>
            }
        },
        { field: 'agreementNo', header: 'Mã tài liệu', width: 140, matchMode: 'contains' },
        { field: 'agreementTypeName', header: 'Loại tài liệu', width: 160, matchMode: 'contains' },
        {
            field: 'statusDescription',
            header: 'Trạng thái',
            width: 120,
            dataType: 'custom' as const,
            customCell() {
                return <Tag value="Đã xóa" severity="danger" />;
            }
        },
        {
            field: 'mainContent',
            header: 'File ký',
            width: 220,
            dataType: 'custom' as const,
            customCell(row: any) {
                if (!row.mainContent) return <span className="text-gray-500">Chưa có file</span>;
                return (
                    <div className="flex align-items-center gap-2">
                        <i className={`pi ${row.mainContent.contentType === 'application/pdf' ? 'pi-file-pdf' : 'pi-file-word'} text-xl`}></i>
                        <div>
                            <div className="font-medium">{row.mainContent.fileName}</div>
                            <small className="text-gray-500">{row.mainContent.contentType?.split('/')?.[1]?.toUpperCase()}</small>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'contentCount',
            header: 'Số file',
            width: 110,
            dataType: 'custom' as const,
            customCell(row: any) {
                const count = row.contentCount || 0;
                return (
                    <Tag
                        value={`${count} file`}
                        severity="info"
                        style={{ cursor: count > 0 ? 'pointer' : 'default' }}
                        onClick={() => count > 0 && handleShowFiles(row)}
                        title={count > 0 ? 'Click để xem danh sách file' : ''}
                    />
                );
            }
        },
        { field: 'lastUpdatedStamp', header: 'Thời gian xóa', width: 160, dataType: 'date' }
    ];

    const { render: renderDraft, reloadLazyData: reloadDraft } = useDataTable({
        tableHeader: (
            <div className="flex align-items-center justify-content-between flex-wrap gap-2">
                <span>Tài liệu nháp</span>
                {/* <div className="flex gap-2">
          <Button
            label="Upload Excel"
            icon="pi pi-upload"
            size="small"
            severity="help"
            onClick={() => setDisplayUploadExcel(true)}
          />
        </div> */}
            </div>
        ),
        dataKey: 'agreementId',
        indexColumnWidth: 45,
        actionColumnWidth: 140,
        columns: draftColumns,
        getList: lazyLoadEvent => {
            return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_DRAFT').then(result => {
                if (result.listData && Array.isArray(result.listData)) {
                    result.listData = result.listData.map((item: any) => ({
                        ...item,
                        mainContent: item.mainFileName || item.mainContentType ? {
                            fileName: item.mainFileName,
                            contentType: item.mainContentType,
                            contentLocation: item.mainContentLocation
                        } : null
                    }));
                }
                return {
                    listData: result.listData || [],
                    totalRecords: result.totalRecords || (result.listData || []).length
                };
            });
        },
        initActions(items: Array<any>) {
            if (items) {
                items.forEach(item => {
                    item.actions = [
                        { icon: 'pi pi-eye', title: 'Xem chi tiết', className: 'p-button-info', command: () => handleView(item) },
                        { icon: 'pi pi-pen-to-square', title: 'Ký tại đây', className: 'p-button-info', command: () => handleSign(item) },
                        { icon: 'pi pi-user-edit', title: 'Bắt đầu ký', className: 'p-button-success', command: () => handleSignFromDraft(item) },
                        { icon: 'pi pi-send', title: 'Gửi email', className: 'p-button-help', command: () => { if (!sendingEmail) handleSendEmail(item); } },
                        { icon: 'pi pi-pencil', title: 'Chỉnh sửa', className: 'p-button-warning', command: () => handleEdit(item) },
                        { icon: 'pi pi-trash', title: 'Xóa', className: 'p-button-danger', command: () => handleDelete(item) }
                    ];
                });
            }
        },
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    // DataTable for Trash tab
    const { render: renderTrash, reloadLazyData: reloadTrash } = useDataTable({
        tableHeader: headerResult,
        dataKey: 'agreementId',
        indexColumnWidth: 45,
        actionColumnWidth: 140,
        columns: trashColumns,
        getList: getTrashList,
        initActions(items: Array<any>) {
            items?.forEach(item => {
                item.actions = [
                    { icon: 'pi pi-eye', title: 'Xem chi tiết', className: 'p-button-info', command: () => handleView(item) },
                    { icon: 'pi pi-refresh', title: 'Khôi phục', className: 'p-button-success', command: () => handleRestore(item) }
                ];
            });
        },
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    const reloadLazyData = () => {
        reloadDraft();
        reloadInProgress();
        reloadCompleted();
        reloadCancelled();
        reloadTrash();
    };

    useEffect(() => { reloadLazyData(); }, []);

    useEffect(() => {
        if (fileDialogMainFiles.length === 0 || !displayFileDialog) return;

        const loadFiles = async () => {
            for (const file of fileDialogMainFiles) {
                const fileId = file?.fileId || file?.description;
                const isGoogleFile = file?.contentLocationTypeEnumId === 'CntLocGoogleDrive';
                const cacheKey = `main_${fileId || file.agreementContentId || fileDialogMainFiles.indexOf(file)}`;

                if (fileDialogMainFileReady[cacheKey]) continue;

                if (isGoogleFile && fileId) {
                    try {
                        if (!fileDialogOpenedFileIdsRef.current.has(fileId)) {
                            if (displayFileDialog?.agreementId) {
                                await AgreementService.openContent(displayFileDialog.agreementId, fileId);
                            }
                            fileDialogOpenedFileIdsRef.current.add(fileId);
                        }

                        const blob = await Oauth2GoogleService.getPdf(fileId);
                        const blobUrl = URL.createObjectURL(blob);
                        setFileDialogMainFileBlobUrls(prev => {
                            const next = { ...prev, [cacheKey]: blobUrl };
                            fileDialogMainFileBlobUrlsRef.current = next;
                            return next;
                        });
                        setFileDialogMainFileReady(prev => ({ ...prev, [cacheKey]: true }));
                    } catch (err) {
                        console.error('Error loading Google file:', err);
                        setFileDialogMainFileReady(prev => ({ ...prev, [cacheKey]: true }));
                    }
                } else {
                    setFileDialogMainFileReady(prev => ({ ...prev, [cacheKey]: true }));
                }
            }
        };

        loadFiles();
    }, [fileDialogMainFiles, displayFileDialog]);

    useEffect(() => {
        return () => {
            Object.values(fileDialogMainFileBlobUrlsRef.current).forEach(url => {
                if (url && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
            Object.values(fileDialogAttachmentFileBlobUrlsRef.current).forEach(url => {
                if (url && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
            fileDialogOpenedFileIdsRef.current.forEach(fileId => {
                if (displayFileDialog?.agreementId) {
                    AgreementService.closeContent(displayFileDialog.agreementId, fileId).catch(err => {
                        console.error('Error closing editor permission:', err);
                    });
                }
            });
            fileDialogOpenedFileIdsRef.current.clear();
        };
    }, []);

    const closeFileDialog = () => {
        fileDialogOpenedFileIdsRef.current.forEach(fileId => {
            if (displayFileDialog?.agreementId) {
                AgreementService.closeContent(displayFileDialog.agreementId, fileId).catch(err => {
                    console.error('Error closing editor permission:', err);
                });
            }
        });
        fileDialogOpenedFileIdsRef.current.clear();
        setDisplayFileDialog(null);
    };

    const handleUploadAttachment = async (event: any) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const files = event.files;
        if (!files || files.length === 0) {
            ToastService.error('Vui lòng chọn file để upload');
            return;
        }

        setUploadingAttachment(true);
        try {
            for (const file of files) {
                const res = await AgreementService.uploadFile(file, displayUploadAttachmentDialog.agreementId, 'N');
                if (!(res && res.success === 'Y')) {
                    throw new Error(res?.error || `Không thể upload ${file.name}`);
                }
            }
            ToastService.success('Upload file đính kèm thành công');
            setDisplayUploadAttachmentDialog(null);
            if (fileUploadAttachmentRef.current) {
                fileUploadAttachmentRef.current.clear();
            }
            reloadLazyData();
        } catch (error: any) {
            ToastService.error(error?.message || 'Có lỗi khi upload file đính kèm');
        } finally {
            setUploadingAttachment(false);
        }
    };

    useEffect(() => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const loadData = async () => {
            try {
                const infoRes = await AgreementService.getAgreementInfo(displayUploadAttachmentDialog.agreementId);
                if (infoRes && infoRes.success === 'Y') {
                    const mappedAttached = (infoRes.attachmentFiles || [])
                        .filter((f: any) => f.fileId)
                        .map((f: any, idx: number) => {
                            const seqNum = f.sequenceNum ?? f.configSequenceNum ?? f.agreementItemSeq ?? null;
                            const normalizedSeq = seqNum !== null && seqNum !== undefined ? Number(seqNum) : null;
                            const fileName = f.fileName || '';
                            const extension = fileName ? getFileExtension(fileName) : '';
                            const agreementContentId = f.agreementContentId;
                            return {
                                agreementContentId: agreementContentId,
                                name: fileName,
                                size: 0,
                                type: f.contentType,
                                file: undefined,
                                extension,
                                googleFileId: f.fileId,
                                fileId: f.fileId,
                                id: f.fileId,
                                googleFileUrl: f.contentLocation,
                                contentLocation: f.contentLocation,
                                isMainFile: false,
                                sequenceNum: normalizedSeq,
                                configSequenceNum: normalizedSeq,
                                agreementFormTypeEnumId: f.agreementFormTypeEnumId || null,
                                agreementFormDate: f.agreementFormDate || null
                            };
                        });
                    setUploadDialogAttachedFiles(mappedAttached);

                    const items = Array.isArray(infoRes.attachmentFiles) ? infoRes.attachmentFiles : [];
                    setUploadDialogDocumentTypeItems(items);

                    const meta: Record<string, { formType?: string | null; receivedDate?: Date | null }> = {};
                    items.forEach((item: any, idx: number) => {
                        const seq = resolveConfigItemSeq(item, idx);
                        if (!seq) return;
                        const seqKey = String(seq);
                        const existingFile = mappedAttached.find((f: any) => Number(f.sequenceNum ?? f.configSequenceNum) === Number(seq));
                        const fileFormType = existingFile ? normalizeFormTypeValue(existingFile.agreementFormTypeEnumId) : null;
                        const fileDate = existingFile?.agreementFormDate ? new Date(existingFile.agreementFormDate) : null;
                        meta[seqKey] = {
                            formType: normalizeFormTypeValue(fileFormType ?? null),
                            receivedDate: fileDate ?? null
                        };
                    });
                    setUploadDialogDocumentTypeItemMeta(meta);
                }
            } catch (error) {
                ToastService.error('Không thể tải thông tin tài liệu');
            }
        };

        loadData();
    }, [displayUploadAttachmentDialog]);

    useEffect(() => {
        CommonService.getFileTypes()
            .then((res: any) => {
                if (res?.listData && Array.isArray(res.listData)) {
                    setUploadDialogFileTypes(res.listData);
                } else if (Array.isArray(res?.list)) {
                    setUploadDialogFileTypes(res.list);
                } else if (Array.isArray(res)) {
                    setUploadDialogFileTypes(res);
                } else {
                    setUploadDialogFileTypes([]);
                }
            })
            .catch(() => {
                setUploadDialogFileTypes([]);
            });
    }, []);

    const handleUploadDialogItemUpload = (item: any, idx: number) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;
        const seq = resolveConfigItemSeq(item, idx);
        if (!seq) {
            ToastService.error('Không xác định được hạng mục file.');
            return;
        }
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.doc,.docx';
        input.onchange = async (e: any) => {
            const file = e.target.files?.[0];
            if (!file) return;
            try {
                setUploadingAttachment(true);
                const res = await GoogleService.uploadFile(file);
                if (!(res && res.success === 'Y')) {
                    throw new Error(res?.error || `Không thể upload ${file.name}`);
                }
                const uploadedFile = {
                    name: res.fileName || file.name,
                    size: file.size,
                    type: file.type,
                    file: undefined,
                    extension: getFileExtension(file.name),
                    googleFileId: res.fileId,
                    googleFileUrl: res.fileUrl,
                    isMainFile: false,
                    sequenceNum: seq,
                    configSequenceNum: seq
                };
                setUploadDialogAttachedFiles(prev => {
                    const filtered = prev.filter(f => Number(f?.sequenceNum ?? f?.configSequenceNum) !== Number(seq));
                    const normalFiles = filtered.filter(f => f.sequenceNum === null || typeof f.sequenceNum === 'undefined');
                    const configFiles = filtered.filter(f => !(f.sequenceNum === null || typeof f.sequenceNum === 'undefined'));
                    return [...configFiles, uploadedFile, ...normalFiles];
                });
                ToastService.success(`Đã gắn tệp cho hạng mục #${seq}`);
                reloadLazyData();
            } catch (error: any) {
                ToastService.error(error?.message || 'Không thể tải tệp cho hạng mục');
            } finally {
                setUploadingAttachment(false);
            }
        };
        input.click();
    };

    const handleUploadDialogItemMetaChange = (seqKey: string, field: 'formType' | 'receivedDate', value: any) => {
        const nextValue = field === 'formType' ? normalizeFormTypeValue(value) : value;
        setUploadDialogDocumentTypeItemMeta(prev => ({
            ...prev,
            [seqKey]: {
                ...prev[seqKey],
                [field]: nextValue
            }
        }));
    };

    const handleUploadDialogViewFile = async (file: any) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const fileId = file?.fileId || file?.googleFileId || file?.id;
        if (!fileId) {
            ToastService.error('Không tìm thấy file ID để xem');
            return;
        }

        try {
            setUploadingAttachment(true);
            setUploadDialogSelectedFile(file);
            setShowUploadDialogFileViewer(true);
            setUploadDialogViewerUrl(null);

            await AgreementService.openContent(displayUploadAttachmentDialog.agreementId, fileId);

            const blob = await Oauth2GoogleService.getPdf(fileId);
            const blobUrl = URL.createObjectURL(blob);
            setUploadDialogViewerUrl(blobUrl);

            setTimeout(() => {
                AgreementService.closeContent(displayUploadAttachmentDialog.agreementId, fileId).catch(err => {
                    console.error('Error closing file permission:', err);
                });
            }, 1000);
        } catch (error: any) {
            console.error('Error viewing file:', error);
            ToastService.error(error?.message || 'Không thể xem file');
            setShowUploadDialogFileViewer(false);
            try {
                await AgreementService.closeContent(displayUploadAttachmentDialog.agreementId, fileId);
            } catch (closeErr) {
                console.error('Error closing file permission after error:', closeErr);
            }
        } finally {
            setUploadingAttachment(false);
        }
    };

    const handleCloseUploadDialogFileViewer = () => {
        if (uploadDialogViewerUrl) {
            URL.revokeObjectURL(uploadDialogViewerUrl);
            setUploadDialogViewerUrl(null);
        }
        setShowUploadDialogFileViewer(false);
        setUploadDialogSelectedFile(null);
    };

    const handleUploadDialogFileRemove = async (file: any) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const targetId = file?.googleFileId || file?.fileId || file?.id || null;

        setUploadDialogAttachedFiles(prev => prev.filter(f => {
            const fId = f.googleFileId || f.fileId || f.id || null;
            return fId !== targetId;
        }));
    };

    const handleSaveUploadDialogMetadata = async () => {
        if (!displayUploadAttachmentDialog?.agreementId) return;
        try {
            setUploadingAttachment(true);

            let valid = true;
            let errorMessage = '';

            // Validate Hình thức cho từng hạng mục (giống logic ở màn hình tạo tài liệu)
            if (Array.isArray(uploadDialogDocumentTypeItems) && uploadDialogDocumentTypeItems.length > 0) {
                const missingMethod: string[] = [];
                uploadDialogDocumentTypeItems.forEach((item: any, idx: number) => {
                    const seq = resolveConfigItemSeq(item, idx);
                    if (!seq) return;
                    const seqKey = String(seq);

                    const isRequired = item?.isRequire === 'Y' || item?.isRequired === true || item?.required === true;
                    const hasFile = uploadDialogAttachedFiles.some((f: any) => {
                        const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                        return Number(fileSeq) === Number(seq);
                    });

                    // Bỏ qua nếu không bắt buộc và chưa có file
                    if (!isRequired && !hasFile) return;

                    const meta = uploadDialogDocumentTypeItemMeta[seqKey];
                    if (!meta?.formType) {
                        const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
                        missingMethod.push(desc);
                    }
                });

                if (missingMethod.length > 0) {
                    valid = false;
                    errorMessage = `Vui lòng chọn Hình thức cho: ${missingMethod.join(', ')}`;
                }
            }

            // Validate Ngày nhận cho các hạng mục có Hình thức = ATTACH_SCAN
            if (valid && Array.isArray(uploadDialogDocumentTypeItems) && uploadDialogDocumentTypeItems.length > 0) {
                const missingDateItems: string[] = [];
                uploadDialogDocumentTypeItems.forEach((item: any, idx: number) => {
                    const seq = resolveConfigItemSeq(item, idx);
                    if (!seq) return;
                    const seqKey = String(seq);

                    const meta = uploadDialogDocumentTypeItemMeta[seqKey];
                    const file = uploadDialogAttachedFiles.find((f: any) => {
                        const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                        return Number(fileSeq) === Number(seq);
                    });

                    const normalizedFormType =
                        meta?.formType ??
                        (file?.agreementFormTypeEnumId ? normalizeFormTypeValue(file.agreementFormTypeEnumId) : null);

                    if (normalizedFormType === 'ATTACH_SCAN') {
                        const effectiveDateValue =
                            meta?.receivedDate ??
                            (file?.agreementFormDate ? new Date(file.agreementFormDate) : null);
                        if (!effectiveDateValue) {
                            const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
                            missingDateItems.push(desc);
                        }
                    }
                });

                if (missingDateItems.length > 0) {
                    valid = false;
                    errorMessage = `Vui lòng nhập Ngày nhận cho: ${missingDateItems.join(', ')}`;
                }
            }

            // Validate bắt buộc phải có file cho các hạng mục required
            if (valid && Array.isArray(uploadDialogDocumentTypeItems) && uploadDialogDocumentTypeItems.length > 0) {
                const requiredItems = uploadDialogDocumentTypeItems.filter((item: any) => {
                    const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
                    return flag === 'Y' || flag === true;
                });

                if (requiredItems.length > 0) {
                    const missingDescriptions: string[] = [];
                    requiredItems.forEach((item: any, idx: number) => {
                        const seq = resolveConfigItemSeq(item, idx);
                        if (!seq) return;
                        const hasFile = uploadDialogAttachedFiles.some((file: any) => {
                            const fileSeq = file?.sequenceNum ?? file?.configSequenceNum;
                            return Number(fileSeq) === Number(seq);
                        });
                        if (!hasFile) {
                            const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
                            missingDescriptions.push(desc);
                        }
                    });

                    if (missingDescriptions.length > 0) {
                        valid = false;
                        errorMessage = `Vui lòng tải lên các tệp bắt buộc: ${missingDescriptions.join(', ')}`;
                    }
                }
            }

            if (!valid) {
                if (errorMessage) {
                    ToastService.error(errorMessage);
                }
                return;
            }

            const formatDateForAPI = (date: Date | null) => {
                if (!date) return undefined;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const hours = String(d.getHours()).padStart(2, '0');
                const minutes = String(d.getMinutes()).padStart(2, '0');
                const seconds = String(d.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            };

            const attachFile = uploadDialogAttachedFiles
                .filter(file => file.sequenceNum !== null && file.sequenceNum !== undefined)
                .map(file => {
                    const seqKey = String(file.sequenceNum);
                    const meta = uploadDialogDocumentTypeItemMeta[seqKey] || {};
                    const selectedFormType = meta?.formType ?? normalizeFormTypeValue(file.agreementFormTypeEnumId) ?? null;
                    const receivedDateValue = meta?.receivedDate ?? (file.agreementFormDate ? new Date(file.agreementFormDate) : null);
                    return {
                        agreementContentId: file.agreementContentId,
                        sequenceNum: file.sequenceNum,
                        fileId: file.googleFileId || file.fileId || file.id,
                        fileName: file.name,
                        receivedDate: receivedDateValue ? formatDateForAPI(receivedDateValue) : undefined,
                        agreementFormTypeEnumId: selectedFormType || file.agreementFormTypeEnumId || null,
                        agreementFormDate: receivedDateValue ? formatDateForAPI(receivedDateValue) : (file.agreementFormDate ? formatDateForAPI(new Date(file.agreementFormDate)) : undefined)
                    };
                });

            const res = await AgreementService.updateAgreementFiles(displayUploadAttachmentDialog.agreementId, { attachFile });
            if (res && res.success === 'Y') {
                ToastService.success('Cập nhật file đính kèm thành công');
                setDisplayUploadAttachmentDialog(null);
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể cập nhật file đính kèm');
            }
        } catch (error: any) {
            ToastService.error(error?.message || 'Có lỗi khi cập nhật file đính kèm');
        } finally {
            setUploadingAttachment(false);
        }
    };

    return (
        <div className="card border-none shadow-1 border-round-xl" style={{ backgroundColor: 'var(--surface-ground)' }}>
            <style dangerouslySetInnerHTML={{
                __html: `
                .tai-lieu-ky-table .p-datatable-thead > tr:nth-child(2) > th {
                    position: sticky !important;
                    top: 38px !important;
                    z-index: 9 !important;
                    background: var(--surface-card) !important;
                }
                .tai-lieu-ky-table .p-datatable-thead > tr:first-child > th {
                    position: sticky !important;
                    top: 0 !important;
                    z-index: 10 !important;
                    background: var(--surface-card) !important;
                }
            `}} />
            <div className="col-12">
                <h3 className="m-0 mb-2">Quản lý tài liệu</h3>
            </div>
            <div className="col-12 pb-0" style={{ maxHeight: 'calc(100vh - 12rem)' }}>
                <Toast ref={toast} />
                <TabView activeIndex={activeTabIndex} onTabChange={handleTabChange}>
                    <TabPanel header="Tài liệu nháp">
                        <div className="tai-lieu-ky-table">
                            {renderDraft()}
                        </div>
                    </TabPanel>
                    <TabPanel header="Đang xử lý">
                        <div className="tai-lieu-ky-table">
                            {renderInProgress()}
                        </div>
                    </TabPanel>
                    <TabPanel header="Hoàn thành">
                        <div className="tai-lieu-ky-table">
                            {renderCompleted()}
                        </div>
                    </TabPanel>
                    <TabPanel header="Đã hủy">
                        <div className="tai-lieu-ky-table">
                            {renderCancelled()}
                        </div>
                    </TabPanel>
                    <TabPanel header="Thùng rác">
                        <div className="tai-lieu-ky-table">
                            {renderTrash()}
                        </div>
                    </TabPanel>
                </TabView>
            </div>
            <UploadExcel display={displayUploadExcel} setDisplay={setDisplayUploadExcel} reloadLazyData={reloadDraft} agreementId={displayUploadAttachmentDialog?.agreementId} />
            <Dialog header="Chọn đối tượng ký" visible={!!displaySignerDialog} style={{ width: '70rem' }} onHide={() => setDisplaySignerDialog(null)}
                footer={(
                    <div className="flex justify-content-end gap-2">
                        <Button label="Ký" icon="pi pi-check" className="p-button-success p-button-sm" disabled={isSigning} onClick={submitSignSelected} />
                        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" disabled={isSigning} onClick={() => setDisplaySignerDialog(null)} />
                    </div>
                )}
            >
                {renderSignerTable()}
            </Dialog>

            {/* Email dialog */}
            <Dialog
                header="Chọn đối tượng gửi email"
                visible={!!displayEmailDialog}
                style={{ width: '70rem' }}
                onHide={() => {
                    setDisplayEmailDialog(null);
                    setEmailParties([]);
                }}
                footer={(
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Gửi email"
                            icon="pi pi-send"
                            className="p-button-success p-button-sm"
                            disabled={sendingEmail || emailParties.filter(p => p.checked).length === 0}
                            onClick={submitEmailSelected}
                            loading={sendingEmail}
                        />
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            disabled={sendingEmail}
                            onClick={() => {
                                setDisplayEmailDialog(null);
                                setEmailParties([]);
                            }}
                        />
                    </div>
                )}
            >
                {renderEmailTable()}
            </Dialog>

            {/* Loading dialog while signing */}
            <Dialog header={null} visible={isSigning} modal closable={false} closeOnEscape={false} dismissableMask={false} style={{ width: '36rem' }} onHide={() => { }}>
                <div className="flex flex-column align-items-center justify-content-center py-6">
                    <i className="pi pi-spin pi-spinner mb-4" style={{ fontSize: '3rem', color: '#3B82F6' }} />
                    <div className="text-center" style={{ fontWeight: 700, fontSize: '1.75rem', color: '#3B82F6' }}>Đang ký xác thực...</div>
                </div>
            </Dialog>

            {/* Cancel confirmation dialog */}
            <Dialog
                header="Xác nhận hủy tài liệu"
                visible={!!cancelDialog}
                style={{ width: '32rem' }}
                onHide={() => {
                    setCancelDialog(null);
                    setCancelReason('');
                }}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Hủy"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            onClick={() => {
                                setCancelDialog(null);
                                setCancelReason('');
                            }}
                        />
                        <Button
                            label="Xác nhận"
                            icon="pi pi-check"
                            className="p-button-danger p-button-sm"
                            onClick={confirmCancel}
                        />
                    </div>
                }
            >
                <div className="flex flex-column gap-3">
                    <div className="flex align-items-center gap-3">
                        <i className="pi pi-exclamation-triangle text-3xl text-orange-500" />
                        <div>
                            <p className="m-0 mb-2">Bạn có chắc muốn hủy tài liệu này?</p>
                            {cancelDialog?.agreementName && (
                                <p className="m-0 text-sm text-gray-600 font-medium">{cancelDialog.agreementName}</p>
                            )}
                        </div>
                    </div>
                    <div className="field">
                        <label htmlFor="cancelReason" className="block text-900 font-medium mb-2">
                            Lý do hủy <span className="text-red-500">(*)</span>
                        </label>
                        <InputTextarea
                            id="cancelReason"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            rows={4}
                            className="w-full"
                            placeholder="Nhập lý do hủy tài liệu..."
                            autoFocus
                        />
                    </div>
                </div>
            </Dialog>

            {/* File viewer dialog */}
            <Dialog
                header={viewerFileName || 'Xem file'}
                visible={showFileViewer}
                style={{ width: '90vw', height: '90vh', maxWidth: 'none' }}
                onHide={closeFileViewer}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            onClick={closeFileViewer}
                        />
                    </div>
                }
            >
                <div style={{ height: '100%' }}>
                    {viewerUrl ? (
                        <iframe
                            src={viewerUrl}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                            title="PDF Viewer"
                        />
                    ) : (
                        <div className="flex align-items-center justify-content-center h-full">
                            <div className="text-center">
                                <i className="pi pi-spin pi-spinner text-3xl mb-3" />
                                <p>Đang tải file...</p>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>

            {/* File list dialog */}
            <Dialog
                header={`Danh sách file - ${displayFileDialog?.agreementName || ''}`}
                visible={!!displayFileDialog}
                maximized={true}
                draggable={false}
                style={{ width: '95vw', height: '90vh', maxWidth: 'none' }}
                onHide={closeFileDialog}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            onClick={closeFileDialog}
                        />
                    </div>
                }
            >
                {(fileDialogMainFiles.length > 0 || fileDialogAttachmentFiles.length > 0) ? (
                    <TabView activeIndex={fileDialogActiveTabIndex} onTabChange={(e) => setFileDialogActiveTabIndex(e.index)}>
                        <TabPanel header={`File chính${fileDialogMainFiles.length > 0 ? ` (${fileDialogMainFiles.length})` : ''}`}>
                            {fileDialogMainFiles.length > 0 ? (
                                fileDialogMainFiles.map((file, index) => {
                                    const fileId = file?.fileId || file?.description;
                                    const isGoogleFile = file?.contentLocationTypeEnumId === 'CntLocGoogleDrive';
                                    const cacheKey = `main_${fileId || file.agreementContentId || index}`;
                                    const isReady = fileDialogMainFileReady[cacheKey];

                                    let mainFileUrl = null;
                                    if (isGoogleFile) {
                                        if (isReady && fileDialogMainFileBlobUrls[cacheKey]) {
                                            mainFileUrl = fileDialogMainFileBlobUrls[cacheKey];
                                        }
                                    }

                                    if (isGoogleFile && !isReady) {
                                        return (
                                            <div key={file.agreementContentId || index} style={{ padding: '2rem', textAlign: 'center' }}>
                                                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                                                <p>Đang tải file...</p>
                                            </div>
                                        );
                                    }

                                    if (mainFileUrl) {
                                        return (
                                            <iframe
                                                key={file.agreementContentId || index}
                                                src={mainFileUrl}
                                                title="File chính"
                                                style={{ width: '100%', height: 'calc(100vh - 200px)', border: 'none' }}
                                            />
                                        );
                                    }
                                    return null;
                                })
                            ) : (
                                <div style={{ padding: '2rem', textAlign: 'center' }}>
                                    <p>Không tìm thấy file ký số để hiển thị.</p>
                                </div>
                            )}
                        </TabPanel>

                        {fileDialogAttachmentFiles.length > 0 && (
                            <TabPanel header={`File đính kèm (${fileDialogAttachmentFiles.length})`}>
                                {fileDialogAttachmentFiles.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '90%', overflow: 'auto' }}>
                                        {fileDialogAttachmentFiles.map((file, index) => {
                                            const isViewing = fileDialogViewingAttachmentIndex === index;

                                            return (
                                                <div key={file.agreementContentId || index} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '1rem' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isViewing ? '0.5rem' : '0' }}>
                                                        <div>
                                                            <strong>{file.fileName || `File đính kèm ${index + 1}`}</strong>
                                                            {file.sequenceNum && <span style={{ marginLeft: '0.5rem', color: '#666' }}>(Thứ tự: {file.sequenceNum})</span>}
                                                        </div>
                                                        <div>
                                                            <Button
                                                                label={isViewing ? "Ẩn" : "Xem"}
                                                                icon={isViewing ? "pi pi-eye-slash" : "pi pi-eye"}
                                                                className="p-button-sm p-button-outlined"
                                                                onClick={async () => {
                                                                    if (!isViewing) {
                                                                        const fileId = file?.fileId || file?.description;
                                                                        const cacheKey = `attachment_${fileId || index}`;

                                                                        if (fileId) {
                                                                            try {
                                                                                if (!fileDialogOpenedFileIdsRef.current.has(fileId)) {
                                                                                    if (displayFileDialog?.agreementId) {
                                                                                        await AgreementService.openContent(displayFileDialog.agreementId, fileId);
                                                                                    }
                                                                                    fileDialogOpenedFileIdsRef.current.add(fileId);
                                                                                }

                                                                                const blob = await Oauth2GoogleService.getPdf(fileId);
                                                                                const blobUrl = URL.createObjectURL(blob);
                                                                                setFileDialogAttachmentFileBlobUrls(prev => {
                                                                                    const next = { ...prev, [cacheKey]: blobUrl };
                                                                                    fileDialogAttachmentFileBlobUrlsRef.current = next;
                                                                                    return next;
                                                                                });
                                                                                setFileDialogAttachmentFileReady(prev => ({ ...prev, [cacheKey]: true }));
                                                                                setFileDialogViewingAttachmentIndex(index);

                                                                                setTimeout(() => {
                                                                                    if (displayFileDialog?.agreementId) {
                                                                                        AgreementService.closeContent(displayFileDialog.agreementId, fileId).catch(err => {
                                                                                            console.error('Error closing editor permission after preview:', err);
                                                                                        });
                                                                                    }
                                                                                    fileDialogOpenedFileIdsRef.current.delete(fileId);
                                                                                }, 1000);
                                                                            } catch (err) {
                                                                                console.error('Error loading Google file:', err);
                                                                                ToastService.error('Không thể tải file');
                                                                            }
                                                                        }
                                                                    } else {
                                                                        const fileId = file?.fileId || file?.description;
                                                                        if (fileId && fileDialogOpenedFileIdsRef.current.has(fileId)) {
                                                                            if (displayFileDialog?.agreementId) {
                                                                                AgreementService.closeContent(displayFileDialog.agreementId, fileId).then(() => {
                                                                                    fileDialogOpenedFileIdsRef.current.delete(fileId);
                                                                                }).catch(err => {
                                                                                    console.error('Error closing editor permission:', err);
                                                                                });
                                                                            }
                                                                        }
                                                                        setFileDialogViewingAttachmentIndex(null);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {isViewing && (() => {
                                                        const fileId = file?.fileId || file?.description;
                                                        const cacheKey = `attachment_${fileId || index}`;
                                                        const isReady = fileDialogAttachmentFileReady[cacheKey];

                                                        if (!isReady) {
                                                            return (
                                                                <div style={{ padding: '2rem', textAlign: 'center', height: 'calc(100vh - 250px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '1px solid #ddd', borderRadius: '4px' }}>
                                                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                                                                    <p>Đang tải file...</p>
                                                                </div>
                                                            );
                                                        }

                                                        const displayUrl = fileDialogAttachmentFileBlobUrls[cacheKey];

                                                        if (!displayUrl) {
                                                            return (
                                                                <div style={{ padding: '2rem', textAlign: 'center', height: 'calc(100vh - 250px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '1px solid #ddd', borderRadius: '4px' }}>
                                                                    <p>Không thể tải file</p>
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <iframe
                                                                src={displayUrl}
                                                                title={file.fileName || `File đính kèm ${index + 1}`}
                                                                style={{ width: '100%', height: 'calc(100vh - 250px)', border: '1px solid #ddd', borderRadius: '4px' }}
                                                            />
                                                        );
                                                    })()}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                                        <p>Chưa có file đính kèm</p>
                                    </div>
                                )}
                            </TabPanel>
                        )}
                    </TabView>
                ) : (
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <p>Không tìm thấy file để hiển thị.</p>
                    </div>
                )}
            </Dialog>

            {/* Upload attachment dialog */}
            <Dialog
                header={`${displayUploadAttachmentDialog?.agreementName || ''}`}
                visible={!!displayUploadAttachmentDialog}
                style={{ width: '95vw', maxWidth: '1200px' }}
                onHide={() => {
                    setDisplayUploadAttachmentDialog(null);
                    setUploadDialogDocumentTypeItems([]);
                    setUploadDialogDocumentTypeItemMeta({});
                    setUploadDialogAttachedFiles([]);
                    setUploadDialogAgreementType(null);
                }}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            disabled={uploadingAttachment}
                            onClick={() => {
                                setDisplayUploadAttachmentDialog(null);
                                setUploadDialogDocumentTypeItems([]);
                                setUploadDialogDocumentTypeItemMeta({});
                                setUploadDialogAttachedFiles([]);
                                setUploadDialogAgreementType(null);
                            }}
                        />
                        <Button
                            label="Lưu"
                            icon="pi pi-check"
                            className="p-button-success p-button-sm"
                            disabled={uploadingAttachment}
                            onClick={handleSaveUploadDialogMetadata}
                        />
                    </div>
                }
            >
                <div className="flex flex-column gap-3">
                    {uploadDialogDocumentTypeItemsLoading ? (
                        <div className="flex align-items-center gap-2 mt-1 text-sm text-blue-500">
                            <i className="pi pi-spin pi-spinner" />
                            <span>Đang tải cấu hình...</span>
                        </div>
                    ) : uploadDialogDocumentTypeItems.length > 0 ? (
                        <div className="border-2 border-dashed border-blue-200 border-round p-2 mt-3" style={{ overflowX: 'auto' }}>
                            <table className="w-full text-sm" style={{ tableLayout: 'fixed', minWidth: '900px' }}>
                                <thead>
                                    <tr className="text-left bg-blue-50">
                                        <th style={{ width: '50px' }} className="p-2 text-center">#</th>
                                        <th style={{ width: '260px' }} className="p-2">Mô tả tài liệu</th>
                                        <th style={{ width: '320px' }} className="p-2">Tệp tài liệu</th>
                                        <th style={{ width: '165px' }} className="p-2 text-center">Hình thức</th>
                                        <th style={{ width: '190px' }} className="p-2 text-center">Ngày nhận</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploadDialogDocumentTypeItems.map((item: any, idx: number) => {
                                        const seq = resolveConfigItemSeq(item, idx);
                                        const seqKey = seq ? String(seq) : `idx-${idx}`;
                                        const isRequired =
                                            (() => {
                                                const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
                                                return flag === 'Y' || flag === true;
                                            })();
                                        const meta = uploadDialogDocumentTypeItemMeta[seqKey] || {};
                                        const formType = meta?.formType;
                                        const file = uploadDialogAttachedFiles.find((f: any) => {
                                            const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                                            return Number(fileSeq) === Number(seq);
                                        });
                                        return (
                                            <tr key={seqKey} className="border-bottom-1 surface-border">
                                                <td className="p-2 text-center font-semibold" style={{ width: '50px' }}>
                                                    {seq ?? idx + 1}
                                                </td>
                                                <td className="p-2" style={{ width: '260px' }}>
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            maxWidth: '100%',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                        title={getFileTypeName(item)}
                                                    >
                                                        {getFileTypeName(item)}
                                                        {isRequired && <span className="text-red-500 ml-1">*</span>}
                                                    </span>
                                                </td>
                                                <td className="p-2" style={{ width: '320px' }}>
                                                    <div
                                                        className="flex align-items-center gap-2"
                                                        style={{ flexWrap: 'nowrap', width: '100%' }}
                                                    >
                                                        {!file && (
                                                            <Button
                                                                type="button"
                                                                label="Chọn tệp"
                                                                icon="pi pi-folder"
                                                                className="p-button-sm"
                                                                style={{ flexShrink: 0, minWidth: '100px' }}
                                                                onClick={() => handleUploadDialogItemUpload(item, idx)}
                                                                disabled={uploadingAttachment}
                                                            />
                                                        )}
                                                        <span
                                                            className="text-gray-600"
                                                            style={{
                                                                display: 'inline-block',
                                                                flex: '1 1 auto',
                                                                minWidth: 0,
                                                                maxWidth: '320px',
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            }}
                                                            title={file ? file.name : 'Không có tệp nào được chọn'}
                                                        >
                                                            {file ? file.name : 'Không có tệp nào được chọn'}
                                                        </span>
                                                        {file && (
                                                            <div className="flex align-items-center gap-1" style={{ flexShrink: 0 }}>
                                                                {(file.googleFileUrl || file.contentLocation) && (
                                                                    <Button
                                                                        type="button"
                                                                        icon="pi pi-eye"
                                                                        className="p-button-rounded p-button-text p-button-info p-button-sm"
                                                                        tooltip="Xem file"
                                                                        style={{ width: '32px', height: '32px', padding: 0 }}
                                                                        onClick={() => handleUploadDialogViewFile(file)}
                                                                        disabled={uploadingAttachment}
                                                                    />
                                                                )}
                                                                <Button
                                                                    type="button"
                                                                    icon="pi pi-trash"
                                                                    className="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                                    tooltip="Xóa"
                                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                                    onClick={() => handleUploadDialogFileRemove(file)}
                                                                    disabled={uploadingAttachment}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="p-2 text-center" style={{ width: '165px' }}>
                                                    <Dropdown
                                                        value={meta?.formType ?? null}
                                                        options={uploadDialogFormTypeOptions}
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        placeholder="Chọn"
                                                        className="w-full"
                                                        onChange={(e) => handleUploadDialogItemMetaChange(seqKey, 'formType', e.value)}
                                                        disabled={uploadingAttachment}
                                                    />
                                                </td>
                                                <td className="p-2 text-center" style={{ width: '190px' }}>
                                                    <Calendar
                                                        value={meta?.receivedDate ?? null}
                                                        onChange={(e) => handleUploadDialogItemMetaChange(seqKey, 'receivedDate', e.value)}
                                                        showIcon
                                                        dateFormat="dd/mm/yy"
                                                        placeholder="Chọn ngày"
                                                        className="w-full"
                                                        disabled={uploadingAttachment}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : uploadDialogAttachedFiles.length > 0 ? (
                        <div className="border-2 border-dashed border-blue-200 border-round p-2 mt-3" style={{ overflowX: 'auto' }}>
                            <table className="w-full text-sm" style={{ tableLayout: 'fixed', minWidth: '700px' }}>
                                <thead>
                                    <tr className="text-left bg-blue-50">
                                        <th style={{ width: '60px' }} className="p-2 text-center">#</th>
                                        <th style={{ width: '360px' }} className="p-2">Tệp tài liệu</th>
                                        <th style={{ width: '160px' }} className="p-2 text-center">Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploadDialogAttachedFiles.map((file: any, idx: number) => (
                                        <tr key={file.agreementContentId || file.name || idx} className="border-bottom-1 surface-border">
                                            <td className="p-2 text-center font-semibold" style={{ width: '60px' }}>{idx + 1}</td>
                                            <td className="p-2" style={{ width: '360px' }}>
                                                <span
                                                    style={{
                                                        display: 'inline-block',
                                                        maxWidth: '100%',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                    title={file.fileName || file.name}
                                                >
                                                    {file.fileName || file.name}
                                                </span>
                                            </td>
                                            <td className="p-2 text-center" style={{ width: '160px' }}>
                                                <div className="flex justify-content-center gap-2">
                                                    <Button
                                                        type="button"
                                                        icon="pi pi-eye"
                                                        className="p-button-rounded p-button-text p-button-sm"
                                                        tooltip="Xem"
                                                        onClick={() => handleUploadDialogViewFile(file)}
                                                        disabled={uploadingAttachment}
                                                    />
                                                    <Button
                                                        type="button"
                                                        icon="pi pi-trash"
                                                        className="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                        tooltip="Xóa"
                                                        onClick={() => handleUploadDialogFileRemove(file)}
                                                        disabled={uploadingAttachment}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="mt-1 text-sm text-gray-500">
                            Loại tài liệu này chưa có cấu hình file đính kèm.
                        </div>
                    )}
                    {uploadingAttachment && (
                        <div className="flex align-items-center gap-2">
                            <i className="pi pi-spin pi-spinner"></i>
                            <span>Đang xử lý...</span>
                        </div>
                    )}
                </div>
            </Dialog>

            {/* Upload Dialog File Viewer */}
            <Dialog
                header={
                    <div className="flex justify-content-between align-items-center w-full">
                        <div className="flex align-items-center gap-3">
                            <span className="font-semibold text-lg">{uploadDialogSelectedFile?.name || uploadDialogSelectedFile?.fileName || ''}</span>
                        </div>
                    </div>
                }
                visible={showUploadDialogFileViewer}
                style={{ width: '95vw', height: '95vh', maxWidth: 'none' }}
                onHide={handleCloseUploadDialogFileViewer}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            icon="pi pi-times"
                            label="Đóng"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            onClick={handleCloseUploadDialogFileViewer}
                        />
                    </div>
                }
            >
                {uploadDialogSelectedFile && (
                    <div className="flex h-full">
                        <div className="flex-1 pl-3">
                            {uploadDialogViewerUrl ? (
                                <div className="h-full flex flex-column">
                                    <div className="flex-1 border-1 border-gray-300 border-round overflow-hidden">
                                        <iframe
                                            src={uploadDialogViewerUrl}
                                            width="100%"
                                            height="100%"
                                            style={{ border: 'none' }}
                                            title={`PDF Viewer - ${uploadDialogSelectedFile.name || uploadDialogSelectedFile.fileName}`}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="flex align-items-center justify-content-center h-full">
                                    <div className="text-center">
                                        <i className="pi pi-spin pi-spinner text-4xl text-blue-500 mb-3"></i>
                                        <p className="text-lg">Đang tải PDF...</p>
                                        <small className="text-gray-500">Vui lòng chờ trong giây lát</small>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Dialog>
        </div>
    );
};


